// prettier-ignore
export const BuyWine = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18">
    <path fill="currentColor" fillRule="evenodd" d="M.89 4.68a.83.83 0 0 1 .61-.26h15a.83.83 0 0 1 .83.9l-.83 11.24a.83.83 0 0 1-.83.77H2.33a.83.83 0 0 1-.83-.77L.67 5.31a.83.83 0 0 1 .22-.63Zm1.5 1.4.72 9.59h11.78l.71-9.59H2.4Z" clipRule="evenodd"/>
    <path fill="currentColor" fillRule="evenodd" d="M4.83 1.5c0-.46.38-.83.84-.83h6.66c.46 0 .84.37.84.83v5.42a.83.83 0 0 1-1.67 0V2.33h-5v4.59a.83.83 0 1 1-1.67 0V1.5Zm0 11.67c0-.46.38-.84.84-.84h6.66a.83.83 0 1 1 0 1.67H5.67a.83.83 0 0 1-.84-.83Z" clipRule="evenodd"/>
  </svg>
)
